import React, { forwardRef } from "react";
import get from "lodash/get";

import { StyledRadioWrapper } from "./booleanRadioField.style";
import GenericInputField, {
  TYPES,
} from "../../../../genericInputFields/genericInputField";
import { useFormContext } from "react-hook-form";
import useDisableOn from "../hooks/useDisableOn";

const BooleanRadioField = forwardRef(
  (
    { required, options, name, settings = { vertical: false }, externalLabel },
    ref,
  ) => {
    const {
      control,
      formState: { errors },
    } = useFormContext();
    const vertical = settings?.vertical || false;
    const error = get(errors, name);
    const { disableOn } = settings;
    const fieldDisabled = useDisableOn(disableOn);

    if (fieldDisabled) return null;
    return (
      <StyledRadioWrapper ref={ref} $error={error ? 1 : 0} $vertical={vertical}>
        {externalLabel && <span className="label">{externalLabel}</span>}
        <div>
          {options.map((option, index) => (
            <div key={index}>
              <GenericInputField
                type={TYPES.BOOLEAN_RADIO}
                control={control}
                value={option.value}
                name={name}
                label={option.label}
                required={required}
                disabled={fieldDisabled}
                shouldUnregister={true}
              />
            </div>
          ))}
        </div>
        <span className="error">{error?.message || ""}</span>
      </StyledRadioWrapper>
    );
  },
);
BooleanRadioField.displayName = "BooleanRadioField";

export default BooleanRadioField;
